import OvertimeEvent from '@/components/requests/overtime/events/OvertimeEvent'

export default class AttachmentAddedEvent extends OvertimeEvent {
  constructor(event) {
    super(event)
  }

  asText(viewer) {
    return `
      **${this.getActorName(viewer)}**
      ${this._getHaveOrHas(viewer)} uploaded a new
      attachment
    `
  }

  isDeleted() {
    return !!this.event.deleted_at
  }

  getResource() {
    return this.event.resource
  }

  getDeleterName(viewer) {
    if (viewer.id === this.event.resource.deleter_id) {
      return 'You'
    }

    return (
      this.event.resource.deleter.full_name +
      ' ' +
      this._employmentInactiveStatus(this.event.resource.deleter)
    )
  }
}
